import React from 'react';
import Hyperlink from '../../../components/atoms/Hyperlink/Hyperlink';
import { accessKeys } from '../../../types/AccessKeys';
import { useLocation } from 'react-router';
import ILink from '../../../types/ILink';
import { PageType } from '../../../types/api/PageType';
import { FooterLinkIcon } from './FooterLinkIcon';
import { useAppContext } from '../../../contexts/AppContext/AppContext';

export type FooterNavItem = {
  pageLink: ILink;
  pageType: PageType;
};

type FooterLinkProps = {
  item: FooterNavItem
};

export function FooterLink({ item }: FooterLinkProps) {
  const location = useLocation();
  const { userInfo } = useAppContext();

  const accessKeyEnabled = userInfo?.settings?.accessKeysEnabled;

  const isItemActive = (link: FooterNavItem) => {
    return location.pathname.startsWith(link.pageLink.url);
  };

  return (
    <li className="footer__list-item" key={item.pageLink.url}>
      {
        isItemActive(item)
        // eslint-disable-next-line @stylistic/multiline-ternary
          ? (
        // this is a "disabled link", this is the proper markup for that
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a
                className="footer__link-current font-medium-15-19"
                role="link"
                aria-disabled="true"
                aria-current="page"
              >
                <FooterLinkIcon pageType={item.pageType} />
                {item.pageLink.name}
              </a>
            ) : (
              <Hyperlink
                className="footer__link font-medium-15-19"
                to={item.pageLink.url}
                accessKey={item.pageType === 'help' && accessKeyEnabled ? accessKeys.help : undefined}
              >
                <FooterLinkIcon pageType={item.pageType} />
                {item.pageLink.name}
              </Hyperlink>
            )
      }
    </li>
  );
}
